<template>
<div class="waiting" v-show="waiting">
  <div class="waiter">
    <div class="inner one"></div>
    <div class="inner two"></div>
    <div class="inner three"></div>
  </div>
</div>
</template>

<script>
export default {
  name: 'WaitAround',

  data () {
    return {
      waiting: false
    }
  },

  methods: {
    show () {
      this.waiting = true
    },

    hidden () {
      this.waiting = false
    }
  }
}
</script>

<style lang="scss" scoped>
.waiting {
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 99999;

  &.bg {
    background-color: #032e25;
    background-image:
      linear-gradient(
        135deg,
        rgba(0, 0, 0, .2) 0%,
        rgba(0, 0, 0, .1) 25%,
        rgba(0, 0, 0, .2) 50%,
        rgba(0, 0, 0, .1) 75%,
        rgba(0, 0, 0, .2) 100%
      ),
      linear-gradient(
        0deg,
        #001916,
        #04a26d,
        #003730
      );
    background-size: 8px 8px, 100%;
  }

  .waiter {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    perspective: 800px;
    transform: translate(-50%, -50%);
  }

  .inner {
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .one {
    left: 0%;
    top: 0%;
    animation: rotate-one 1s linear infinite;
    border-bottom: 3px solid #67c23a;
  }

  .two {
    right: 0%;
    top: 0%;
    animation: rotate-two 1s linear infinite;
    border-right: 3px solid #409eff;
  }

  .three {
    right: 0%;
    bottom: 0%;
    animation: rotate-three 1s linear infinite;
    border-top: 3px solid #F56c6c;
  }
}

@keyframes rotate-one {
  0% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);
  }
}

@keyframes rotate-two {
  0% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);
  }
}

@keyframes rotate-three {
  0% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);
  }
}
</style>
